module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_105-00d48fa85e374497ef0b7cd42b9f1218.png";